var app = angular.module("leonardo");

var DynamicFinderController = function($scope, ngDialog, NotificationService, PropertyService, TaskService,
                                       DynamicFormDataRestService, DynamicFormRestService) {

  $scope.openDynamicFormDialog = function (task) {
    PropertyService.one(task.property).get({with_deleted:true}).then(function (property) {
      if (task.dynamic_form_data && (task.dynamic_form_data !== 'skip')) {
        var data_id = task.dynamic_form_data.id ? task.dynamic_form_data.id : task.dynamic_form_data;
        DynamicFormDataRestService.one(data_id).get({with_deleted:true}).then(function (data) {
          ngDialog.openConfirm({
            template: 'views/templates/dialog/task/dynamic-form-react.html',
            className: 'ngdialog-theme-default ngdialog-dynamic-form',
            controller: 'TaskDynamicFormDialogReact',
            resolve: {
              formObj: [function () {
                return data.dynamic_form;
              }],
              formDataObj: [function () {
                return data;
              }]
            },
            data: {
              task: task,
              approvalStatus: [TaskService.STATUS_APPROVAL_IN_PROGRESS].includes(task.status.toString()),
              property: property,
              force: true
            }
          });
        });
      }
      else {
        DynamicFormRestService.one(task.dynamic_form).get({with_deleted:true}).then(function (data) {
          ngDialog.openConfirm({
            template: 'views/templates/dialog/task/dynamic-form-react.html',
            className: 'ngdialog-theme-default ngdialog-dynamic-form',
            controller: 'TaskDynamicFormDialogReact',
            resolve: {
              formObj: [function () {
                return data;
              }],
              formDataObj: [function () {
                return null;
              }]
            },
            data: {
              task: task,
              approvalStatus: [TaskService.STATUS_APPROVAL_IN_PROGRESS].includes(task.status.toString()),
              property: property,
              force: true
            }
          }).then(function () {
            // This is intentional do_something blank function
          }, function () {
            return;
          });
        });
      }
    });
  };

  $scope.search = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      return;
    }
    TaskService.taskFinder($scope.action_item_id,{with_deleted:true}).then(function (data) {
      if (!data.dynamic_form) {
        NotificationService.error('This action item have not a dynamic form.');
      }
      else {
        data.status = parseInt(TaskService.STATUS_PENDING);
        $scope.openDynamicFormDialog(data);
      }
    });
  };

};

app.controller('DynamicFinderController', ['$scope', 'ngDialog', 'NotificationService', 'PropertyService', 'TaskService',
  'DynamicFormDataRestService', 'DynamicFormRestService', DynamicFinderController]);